module.exports = __webpack_public_path__ + "img/88.42b75011.jpg";